export default "__VITE_ASSET__2531d04f__"